(() => {
  async function stockCandidates(signal) {
    let url = `${Shopify.routes.root}collections/all?section_id=dm-cart-candidates`;
    const visited = new Set();
    const items = [];
    while (url && !visited.has(url)) {
      visited.add(url);
      const response = await fetch(url, {signal});
      if (!response.ok) throw new Error('Catalog unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(page.querySelector('[data-dm-candidates]').textContent);
      items.push(...data.items);
      if (!data.next) break;
      const next = new URL(data.next, location.origin);
      if (next.origin !== location.origin) throw new Error('Invalid catalog page');
      next.searchParams.set('section_id', 'dm-cart-candidates');
      url = next.pathname + next.search;
    }
    return items;
  }
  function rankCandidates(items, remaining, excluded) {
    const sorted = items.filter(item => !excluded.includes(item.product) && item.price >= remaining)
      .sort((a, b) => a.price - b.price || a.product - b.product || a.variant - b.variant);
    const seen = new Set();
    return sorted.filter(item => {
      if (seen.has(item.product)) return false;
      seen.add(item.product);
      return true;
    }).slice(0, 4);
  }
  if (!customElements.get('dm-cart-recommendations')) {
    customElements.define('dm-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.load(this.controller.signal);
      }
      disconnectedCallback() { this.controller?.abort(); }
      async load(signal) {
        const remaining = Number(this.getAttribute('remaining'));
        if (remaining > 0) {
          try {
            const candidates = rankCandidates(await stockCandidates(signal), remaining, JSON.parse(this.getAttribute('cart-products') || '[]'));
            const cards = await Promise.all(candidates.map(async candidate => {
              const url = new URL(candidate.url, location.origin);
              url.searchParams.set('section_id', 'dm-cart-budget-card');
              url.searchParams.set('variant', candidate.variant);
              const response = await fetch(url.pathname + url.search, {signal});
              if (!response.ok) return null;
              const page = new DOMParser().parseFromString(await response.text(), 'text/html');
              return page.querySelector('dm-cart-recommendation');
            }));
            const valid = cards.filter(Boolean);
            const track = this.querySelector('.dm-cart-recommendations-track');
            if (!signal.aborted && this.isConnected && track && valid.length) {
              track.replaceChildren(...valid.map(card => document.importNode(card, true)));
              this.querySelector('.dm-cart-recommendations-heading p').textContent = 'Completa tu envío gratis';
              return;
            }
          } catch (_) { /* Preserve standard recommendations when the catalog cannot load. */ }
        }
        // The drawer moves outside its Shopify section when opened.
        // Keep its section ID explicitly so recommendations also refresh after cart changes.
        const params = new URLSearchParams({product_id: this.getAttribute('product'), section_id: this.getAttribute('section-id'), intent: 'complementary', limit: '4'});
        try {
          const response = await fetch(`${Shopify.routes.root}recommendations/products?${params}`, {signal});
          if (!response.ok) return;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const recommendations = page.querySelector('dm-cart-recommendations');
          if (!signal.aborted && this.isConnected && recommendations?.childElementCount) {
            this.replaceChildren(...document.importNode(recommendations, true).childNodes);
          }
        } catch (_) { /* Keep the rendered fallback if recommendations cannot load. */ }
      }
    });
  }
  if (!customElements.get('dm-cart-recommendation')) {
    customElements.define('dm-cart-recommendation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-dm-variant]');
          if (!button || button.disabled) return;
          this.querySelector('input[name="id"]').value = button.dataset.dmVariant;
          this.querySelector('input[name="quantity"]').value = button.dataset.dmMin;
          this.querySelector('[data-dm-price]').textContent = button.dataset.dmPrice;
          this.querySelectorAll('[data-dm-variant]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-dm-carousel]');
    if (!control) return;
    const track = control.closest('.dm-cart-recommendations').querySelector('.dm-cart-recommendations-track');
    track.scrollBy({left: track.clientWidth * (control.dataset.dmCarousel === 'next' ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('.dm-cart-drawer cart-discount-field input:not([type="hidden"])')) {
      event.preventDefault();
      event.target.blur();
    }
  });
})();
